import { defineModel } from "../define-model";

export type AgentRunStatus =
	| "queued"
	| "running"
	| "waiting_approval"
	| "succeeded"
	| "failed"
	| "cancelled";

/** Mirrors `AgentRunTriggerRef` in `api/src/agents/types.ts`. */
export type AgentRunTriggerRef =
	| { kind: "manual"; userId: string | null; prompt?: string }
	| { kind: "schedule"; scheduleId: string; triggerKey: string }
	| { kind: "event"; eventId: string; subscriptionId: string; triggerKey: string }
	| { kind: "assistant"; threadId: string; userId: string | null; prompt: string };

export type AgentRun = {
	id: string;
	workspaceId: string;
	projectId: string;
	agentId: string;
	trigger: AgentRunTriggerRef["kind"];
	triggerRef: AgentRunTriggerRef;
	/** `waiting_approval`: proposals of this run wait in the Approvals inbox. */
	status: AgentRunStatus;
	/** Transcript: an assistant thread of kind `agent` (messages + tool calls by `agentRunId`). */
	threadId: string | null;
	summary: string | null;
	error: string | null;
	steps: number;
	costUsd: number;
	millicredits: number;
	startedAt: string | null;
	finishedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		agentRun: AgentRun;
	}
}

export const isOpenAgentRun = (run: Pick<AgentRun, "status"> | undefined) =>
	run?.status === "queued" || run?.status === "running" || run?.status === "waiting_approval";

export const model = defineModel({
	name: "agentRun",
	load: "lazy",
	indexes: ["projectId", "agentId"],
	sort: (a, b) => b.createdAt.localeCompare(a.createdAt),
});
